import { useOrganizationContext } from "@/context";
import { DATE_FORMAT } from "@/utils/common";
import organizationHelper, {
  PAYMENT_ALERT_STATUS_TYPE,
} from "@shared/common/utils/organization-helper";
import dayjs from "dayjs";
import Link from "next/link";

const v2UrlPrefix = process.env.NEXT_PUBLIC_V2_URL_PREFIX;

const PaymentAlert = () => {
  const { currentOrganization } = useOrganizationContext();

  if (!currentOrganization) return null;

  const RenderAlert = () => {
    const { planEndAt, nextBilledAt, billingFailCount, status } =
      currentOrganization;
    const alertStatusCode = organizationHelper.getPaymentAlertStatus(
      planEndAt,
      nextBilledAt,
      billingFailCount,
      status
    );

    switch (alertStatusCode) {
      // case PAYMENT_ALERT_STATUS_TYPE.NOTICE_EXPECT_PLAN:
      //   return (
      //     <Link href={`${v2UrlPrefix}/${currentOrganization.slug}/payment`}>
      //       <div className="flex items-center gap-5 bg-[#000123BF] text-xl text-white justify-center shadow-[0_2px_2px_0_rgba(0,0,0,0.05)] px-9 py-3">
      //         {dayjs(currentOrganization.nextBilledAt).format(DATE_FORMAT)}(결제
      //         예정일) &apos;플랜&lsquo;으로 결제 예정입니다. 결제정보를
      //         확인해주세요.{" "}
      //         <span className="px-4 py-1 text-sm border rounded">클릭</span>
      //       </div>
      //     </Link>
      //   );
      case PAYMENT_ALERT_STATUS_TYPE.PAYMENT_NOT_PROCEED:
        return (
          <Link href={`${v2UrlPrefix}/${currentOrganization.slug}/payment`}>
            <div className="mb-6 flex items-center gap-5 bg-secondary-300 text-neutral-800 justify-center shadow-[0_2px_2px_0_rgba(0,0,0,0.05)] px-9 py-3">
              {dayjs(currentOrganization.nextBilledAt).format(DATE_FORMAT)}{" "}
              결제가 정상적으로 진행되지 않았습니다. 카드 정보를
              다시입력해주세요.
              <span className="px-4 py-1 text-sm border rounded border-neutral-800">
                클릭
              </span>
            </div>
          </Link>
        );
      case PAYMENT_ALERT_STATUS_TYPE.FAIL_PAYMENT:
        return (
          <Link href={`${v2UrlPrefix}/${currentOrganization.slug}/payment`}>
            <div className="mb-6 flex items-center gap-5 bg-[#EB4256B2] text-white justify-center shadow-[0_2px_2px_0_rgba(0,0,0,0.05)] px-9 py-3">
              결제 실패로 서비스 사용이 제한 되었습니다. 카드 정보를
              다시입력해주세요.
              <span className="px-4 py-1 text-sm border rounded">클릭</span>
            </div>
          </Link>
        );
      default:
        return null;
    }
  };

  return <RenderAlert />;
};

export default PaymentAlert;
